"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImagePlaceholder = void 0;
var react_1 = __importStar(require("react"));
var gradient_background_jpg_1 = __importDefault(require("../../../assets/images/gradient_background.jpg"));
var styled_1 = require("./styled");
var ImagePlaceholder = function (_a) {
    var title = _a.title, height = _a.height, fontWeight = _a.fontWeight, _b = _a.aspectRatio, aspectRatio = _b === void 0 ? "5/3" : _b, _c = _a.letterSizeMultiplier, letterSizeMultiplier = _c === void 0 ? 1.8 : _c, _d = _a.strechToFullHeight, strechToFullHeight = _d === void 0 ? false : _d, _e = _a.style, style = _e === void 0 ? {} : _e;
    var containerRef = (0, react_1.useRef)(null);
    var _f = (0, react_1.useState)(200), letterSize = _f[0], setLetterSize = _f[1];
    (0, react_1.useEffect)(function () {
        var calculateLetterSize = function () {
            if (containerRef.current) {
                var containerHeight = containerRef.current.offsetHeight;
                var calculatedSize = containerHeight * letterSizeMultiplier; // Calculate letter size based on container height. Adjust the multiplier to match design requirements
                setLetterSize(calculatedSize);
            }
        };
        calculateLetterSize();
        window.addEventListener('resize', calculateLetterSize);
        // Cleanup listener
        return function () {
            window.removeEventListener('resize', calculateLetterSize);
        };
    }, []);
    var colors = [
        '#9EE4F1',
        '#ABF3BD',
        '#ABBAF3',
        '#C9ABF3',
        '#F3ABC8',
        '#F3DAAB',
        '#F1F3AB',
        '#CAF3AB',
    ];
    var randomColor = (0, react_1.useRef)(colors[Math.floor(Math.random() * colors.length)] + '80');
    var firstLetter = title.charAt(0).toUpperCase();
    return (react_1.default.createElement(styled_1.StyledContainer, { ref: containerRef, aspectRatio: aspectRatio, height: height, strechToFullHeight: strechToFullHeight, style: style },
        react_1.default.createElement(styled_1.StyledImageLayer, null,
            react_1.default.createElement(styled_1.StyledImage, { src: gradient_background_jpg_1.default, alt: title })),
        react_1.default.createElement(styled_1.StyledColorOverlay, { color: randomColor.current }),
        react_1.default.createElement(styled_1.StyledLetterContainer, null,
            react_1.default.createElement(styled_1.StyledLetter, { fontSize: letterSize, fontWeight: fontWeight }, firstLetter))));
};
exports.ImagePlaceholder = ImagePlaceholder;
